import { getThumbnailProps } from '../../../utils/youtubeUtils';
import { TConfigurationsOverviewCard } from '../types/productSeriesDetailConfigurationsOverview.types';

export class ConfigurationCardModel {
  private readonly fields: TConfigurationsOverviewCard;
  constructor(props: TConfigurationsOverviewCard) {
    this.fields = props;
  }

  get assets() {
    return this.fields.assets;
  }

  get button1() {
    return this.fields.button1;
  }

  get button2() {
    return this.fields.button2;
  }

  get description() {
    return this.fields.description;
  }

  get title() {
    return this.fields.title;
  }

  get componentNumber() {
    return this.fields.componentNumber;
  }

  get firstAsset() {
    return this.assets?.[0];
  }

  get isVideo(): boolean {
    return this.firstAsset?.role === 'video' || this.firstAsset?.role === 'extvideo';
  }

  get getVideoUrl() {
    if (this.isVideo) {
      return this.firstAsset?.full;
    }
    return '';
  }

  get getExternalThumbnail(): string {
    if (this.firstAsset?.role === 'extvideo') {
      const { showThumbnail, thumbnailImgSrc } = getThumbnailProps(this.firstAsset?.full, 'hqdefault');
      if (showThumbnail) return thumbnailImgSrc || '';
    }
    return '';
  }
}
